export const renderTagName = (tagNumber, tags) => {
  const findTags = tags?.tagList?.filter((tag) => tag.tagCode === tagNumber);
  return findTags?.[0]?.tagName;
};
